import * as Types from './crudActionTypes.js'

const initialState = {
    table : "Kies een tabel",
    api : "",
    schemeName: ""
};

export default function crud(state = initialState, action) {
    switch (action.type) {
        case Types.SET_CRUDTABLE:
            if(state.table !== action.table) {
                return Object.assign({}, state, {table: action.table});
            }
            return state;
        case Types.SET_TABLEAPI:
            if(state.api !== action.api) {
                return Object.assign({}, state, {api: action.api});
            }
            return state;
        case Types.SET_SCHEMENAME:
            if(state.schemeName !== action.schemeName) {
                return Object.assign({}, state, {schemeName: action.schemeName});
            }
            return state;
        default:
            return state;
    }
}